import { Injectable } from '@angular/core';
import { BaseApiDataService } from 'app/core/storage/base-api-data.service';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { Municipality } from './municipalities.model';

const API_URL = environment.registrarCommandApi;

@Injectable({
  providedIn: 'root',
})
export class MunicipalityCommandService {
  constructor(private dataService: BaseApiDataService<any>) { }

  public registerMunicipality(data: Municipality): Observable<any> {
    return this.dataService.post(`${API_URL}/municipality/register`, {
      name: data.name,
      code: data.code,
      countryId: data.countryId,
      countryIsoCode2: data.countryIsoCode2,
      countryName: data.countryName,
      provinceId: data.provinceId,
      provinceIsoCode: data.provinceIsoCode,
      provinceName: data.provinceName,
      electoralRegionId: data.electoralRegionId,
      electoralRegionCode: data.electoralRegionCode,
      administrativeRegionId: data.administrativeRegionId,
      administrativeRegionCode: data.administrativeRegionCode,
    });
  }
}
